/**
 * @license Copyright (c) Microsoft Corporation. All rights reserved.
 */
var _a, _b, _c, _d, _e, _f, _g, _h;
var CaptchaConfigurationConstants = /** @class */ (function () {
    function CaptchaConfigurationConstants() {
    }
    CaptchaConfigurationConstants.captchaInputIdPrefix = "wlspispSolutionElement";
    CaptchaConfigurationConstants.captchaNewButtonIdPrefix = "wlspispHIPNew";
    CaptchaConfigurationConstants.captchaAudioButtonIdPrefix = "wlspispHIPTo";
    return CaptchaConfigurationConstants;
}());
export { CaptchaConfigurationConstants };
export var MockStrings;
(function (MockStrings) {
    MockStrings["captchaMockTitle"] = "Captcha Title";
    MockStrings["captchaMockNew"] = "Captcha New";
    MockStrings["captchaMockAudio"] = "Captcha Audio";
})(MockStrings || (MockStrings = {}));
export var MockStringTranslations = {
    en: (_a = {},
        _a[MockStrings.captchaMockTitle] = "Enter the characters you see",
        _a[MockStrings.captchaMockNew] = "New",
        _a[MockStrings.captchaMockAudio] = "Audio",
        _a),
    de: (_b = {},
        _b[MockStrings.captchaMockTitle] = "Geben Sie die Zeichen ein, die Sie sehen",
        _b[MockStrings.captchaMockNew] = "Neu",
        _b[MockStrings.captchaMockAudio] = "Audio",
        _b),
    ja: (_c = {},
        _c[MockStrings.captchaMockTitle] = "表示されている文字を入力してください",
        _c[MockStrings.captchaMockNew] = "新規",
        _c[MockStrings.captchaMockAudio] = "オーディオ",
        _c),
    it: (_d = {},
        _d[MockStrings.captchaMockTitle] = "Immetti i caratteri che vedi",
        _d[MockStrings.captchaMockNew] = "Nuovo",
        _d[MockStrings.captchaMockAudio] = "Audio",
        _d),
    nl: (_e = {},
        _e[MockStrings.captchaMockTitle] = "Voer de tekens in die u ziet",
        _e[MockStrings.captchaMockNew] = "Nieuw",
        _e[MockStrings.captchaMockAudio] = "Audio",
        _e),
    fr: (_f = {},
        _f[MockStrings.captchaMockTitle] = "Entrez les caractères que vous voyez",
        _f[MockStrings.captchaMockNew] = "Nouveau",
        _f[MockStrings.captchaMockAudio] = "Audio",
        _f),
    da: (_g = {},
        _g[MockStrings.captchaMockTitle] = "Angiv de tegn, du kan se",
        _g[MockStrings.captchaMockNew] = "Ny(t)",
        _g[MockStrings.captchaMockAudio] = "Lyd",
        _g),
    es: (_h = {},
        _h[MockStrings.captchaMockTitle] = "Escriba los caracteres que ve",
        _h[MockStrings.captchaMockNew] = "Nuevo",
        _h[MockStrings.captchaMockAudio] = "Audio",
        _h)
};
var CaptchaUtils = /** @class */ (function () {
    function CaptchaUtils() {
    }
    CaptchaUtils.getSupportedLanguages = function () {
        return Object.keys(MockStringTranslations).map(function (language) { return language.toLowerCase(); });
    };
    CaptchaUtils.getCaptchaMockTranslation = function (mockString, language) {
        var _a;
        var selectedLanguage = (_a = language === null || language === void 0 ? void 0 : language.toLowerCase()) !== null && _a !== void 0 ? _a : "en";
        var filteredAvailableLanguages = CaptchaUtils.getSupportedLanguages().filter(function (lang) { return lang === selectedLanguage; });
        var finalLanguage = filteredAvailableLanguages && filteredAvailableLanguages.length === 1 ? filteredAvailableLanguages[0] : "en";
        var translations = MockStringTranslations[finalLanguage];
        if (!translations || !translations[mockString]) {
            // Fallback to requested mock string if translation
            // is not found similarly to localization
            return mockString.toString();
        }
        return translations[mockString];
    };
    CaptchaUtils.getInitialLanguage = function () {
        return CaptchaUtils.getSupportedLanguages()[0];
    };
    return CaptchaUtils;
}());
export { CaptchaUtils };
